/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExperienceLevel } from './';
import {
    ExperienceLevelFromJSON,
    ExperienceLevelFromJSONTyped,
    ExperienceLevelToJSON,
} from './';
import type { PriceHistogram } from './';
import {
    PriceHistogramFromJSON,
    PriceHistogramFromJSONTyped,
    PriceHistogramToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExperienceAndPrice
 */
export interface ExperienceAndPrice {
    /**
     * 
     * @type {number}
     * @memberof ExperienceAndPrice
     */
    averagePrice: number;
    /**
     * 
     * @type {number}
     * @memberof ExperienceAndPrice
     */
    count: number;
    /**
     * 
     * @type {ExperienceLevel}
     * @memberof ExperienceAndPrice
     */
    level: ExperienceLevel;
    /**
     * 
     * @type {number}
     * @memberof ExperienceAndPrice
     */
    maxPrice: number;
    /**
     * 
     * @type {number}
     * @memberof ExperienceAndPrice
     */
    minPrice: number;
    /**
     * 
     * @type {PriceHistogram}
     * @memberof ExperienceAndPrice
     */
    priceHistogram: PriceHistogram;
}

/**
 * Check if a given object implements the ExperienceAndPrice interface.
 */
export function instanceOfExperienceAndPrice(value: object): value is ExperienceAndPrice {
    if (!('averagePrice' in value) || value['averagePrice'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('maxPrice' in value) || value['maxPrice'] === undefined) return false;
    if (!('minPrice' in value) || value['minPrice'] === undefined) return false;
    if (!('priceHistogram' in value) || value['priceHistogram'] === undefined) return false;
    return true;
}

export function ExperienceAndPriceFromJSON(json: any): ExperienceAndPrice {
    return ExperienceAndPriceFromJSONTyped(json, false);
}

export function ExperienceAndPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceAndPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'averagePrice': json['averagePrice'],
        'count': json['count'],
        'level': ExperienceLevelFromJSON(json['level']),
        'maxPrice': json['maxPrice'],
        'minPrice': json['minPrice'],
        'priceHistogram': PriceHistogramFromJSON(json['priceHistogram']),
    };
}

export function ExperienceAndPriceToJSON(value?: ExperienceAndPrice | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'averagePrice': value['averagePrice'],
        'count': value['count'],
        'level': ExperienceLevelToJSON(value['level']),
        'maxPrice': value['maxPrice'],
        'minPrice': value['minPrice'],
        'priceHistogram': PriceHistogramToJSON(value['priceHistogram']),
    };
}

